export default "__VITE_ASSET__qFCpDLVP__"